import React from 'react';
/**
 *
 * @deprecated
 */
export const NotificationHubContext = /*#__PURE__*/React.createContext({
  notifications: [],
  addNotifications: () => {},
  setNotifications: () => {},
  removeNotifications: () => {}
});

/**
 *
 * @deprecated
 */
export const useNotificationHubContext = () => React.useContext(NotificationHubContext);